<template>
  <mdb-container>
    <EditServiceStatus/>
  </mdb-container>
</template>

<script>
import { mdbContainer } from "mdbvue";
import EditServiceStatus from "@/components/EditServiceStatus.vue";

export default {
  name: "AddServiceStatus",
  components: {
    mdbContainer,
    EditServiceStatus
  },
  data() {
    return {

    };
  }
};
</script>

<style></style>